import React from "react";
import PropTypes from "prop-types";

import SellOutTotalDesktop from "./SellOutTotalDesktop";

function SellOutTotal({ app, config }) {
  return <SellOutTotalDesktop app={app} config={config} />;
}

SellOutTotal.defaultProps = {
  app: null,
  config: {},
};

SellOutTotal.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutTotal;
